import React, { useEffect, useState, useRef } from "react";
import {
  Table,
  Input,
  Button,
  Popconfirm,
  Form,
  Space,
  Col,
  Row,
  message,
  Select,
  InputNumber,
  Modal,
  Spin,
} from "antd";
import _ from "lodash";
import { useDispatch, useSelector } from "react-redux";
import { PlusOutlined, CloseOutlined } from "@ant-design/icons";
import { ReactComponent as EditIcon } from "../../assets/edit-icon.svg";
import { ReactComponent as SaveIcon } from "../../assets/save-icon.svg";
import { ReactComponent as CrossIcon } from "../../assets/cross-icon.svg";
import sampleImg from "../../assets/user-icon.svg";

import SpinnerComponent from "../../components/spinner";

import { baseURL } from "../../globalUtils/axiosConfig";
import {
  createAutoAssign,
  fetchAutoAssign,
  isAddingAction,
  updateAutoTime,
  updateAutoNow,
  updateAutoAssign,
  fetchAutoAssignTime,
  setStorage,
} from "./redux/actions";

const { Option } = Select;

const AutoAssignTable = ({ canUpdate, canDelete, id }) => {
  const [editingLoading, setEditingLoading] = useState(false);
  // const [editingKey, setEditingKey] = useState('');
  const [editingKey, setEditingKey] = useState(null);
  const [data, setData] = useState([]);
  const [icon, setIcon] = useState(null);
  const [isIconSelected, setIsIconSelected] = useState(false);
  const dispatch = useDispatch();
  const [search, setSearch] = useState({});

  const [req, setReq] = useState(false);

  const [form] = Form.useForm();
  const ref = useRef();
  const isEditing = (record) => record._id === editingKey;

  const {
    allAutoAssign,
    fetchingLoading,
    updateLoading,
    isAdding,
    scheduleMin,
    ...rest
  } = useSelector((state) => state.AutoAssignReducer);

  const [debouncedCallApi] = useState(() =>
    _.debounce(() => setReq((prev) => !prev), 500)
  );

  const [isModalVisible, setIsModalVisible] = useState(false);
  const [isModalVisibles, setIsModalVisibles] = useState(false);

  const [days, setDays] = useState("");
  const [weeks, setWeeks] = useState("");
  const [months, setMonths] = useState("");
  const [totalMinutes, setTotalMinutes] = useState(0);
  const initializTtime = new Date().toISOString();

  const CountdownTimer = ({ lastRunTime, intervalMinutes, updatedAt }) => {
    const [time, setTime] = useState(() => {
      return getRemainingTime(lastRunTime || updatedAt, intervalMinutes);
    });

    const timerRef = useRef(null);

    useEffect(() => {
      if (!intervalMinutes) return;

      const runTime = lastRunTime || updatedAt;
      if (!runTime) return;

      const updateTimer = () => {
        const remaining = getRemainingTime(runTime, intervalMinutes);
        setTime(remaining);

        if (!remaining) {
          clearInterval(timerRef.current);
        }
      };

      updateTimer();
      timerRef.current = setInterval(updateTimer, 1000);

      return () => clearInterval(timerRef.current);
    }, [lastRunTime, updatedAt, intervalMinutes]);

    if ((!lastRunTime && !updatedAt) || !intervalMinutes) return null;

    return (
      <div>
        {time ? (
          <div>
            <h2>Next Auto Assign In:</h2>
            <ul
              style={{
                paddingLeft: "0px",
                backgroundColor: "#f8f8f8",
                marginTop: "10px",
                borderRadius: "3px",
              }}
            >
              {["days", "hours", "minutes", "seconds"].map((unit) => (
                <li
                  key={unit}
                  style={{
                    display: "inline-block",
                    fontSize: "1.5em",
                    listStyleType: "none",
                    padding: "1em",
                    textAlign: "center",
                    textTransform: "uppercase",
                  }}
                >
                  <span
                    style={{
                      display: "block",
                      fontSize: "4.5rem",
                      color: "#50B6F2",
                    }}
                  >
                    {time[unit]}
                  </span>
                  {unit}
                </li>
              ))}
            </ul>
          </div>
        ) : (
          <div style={{ color: "red" }}>
            Auto-assign interval expired or not set
          </div>
        )}
      </div>
    );
  };

  const getRemainingTime = (runTime, intervalMinutes) => {
    if (!runTime || !intervalMinutes) return null;

    const lastRun = new Date(runTime);
    const nextRun = new Date(lastRun.getTime() + intervalMinutes * 60 * 1000);
    const now = new Date();
    const diffMs = nextRun - now;

    if (diffMs <= 0) return null;

    const totalSeconds = Math.floor(diffMs / 1000);
    const days = Math.floor(totalSeconds / (60 * 60 * 24));
    const hours = Math.floor((totalSeconds % (60 * 60 * 24)) / (60 * 60));
    const minutes = Math.floor((totalSeconds % (60 * 60)) / 60);
    const seconds = totalSeconds % 60;

    return { days, hours, minutes, seconds };
  };

  useEffect(() => {
    if (scheduleMin?.auto_interval_time) {
      setDays("");
      setWeeks("");
      setMonths("");
      setTotalMinutes(scheduleMin?.auto_interval_time);

      const { days, weeks, months } = calculateFromMinutes(
        scheduleMin?.auto_interval_time
      );

      if (months > 0) {
        setMonths(months);
      } else if (weeks > 0) {
        setWeeks(weeks);
      } else if (days > 0) {
        setDays(days);
      }
    }
  }, [scheduleMin]);

  const handleDaysChange = (e) => {
    setDays(e);
    setWeeks("");
    setMonths("");
    calculateMinutes(e, "days");
  };

  const handleWeeksChange = (e) => {
    setDays("");
    setWeeks(e);
    setMonths("");
    calculateMinutes(e, "weeks");
  };

  const handleMonthsChange = (e) => {
    setDays("");
    setWeeks("");
    setMonths(e);
    calculateMinutes(e, "months");
  };

  const calculateMinutes = (value, type) => {
    let minutes = 0;
    if (!isNaN(value) && value !== "") {
      if (type === "days") {
        minutes = value * 24 * 60;
      } else if (type === "weeks") {
        minutes = value * 7 * 24 * 60;
      } else if (type === "months") {
        minutes = value * 30 * 24 * 60;
      }
    }
    setTotalMinutes(minutes);
  };

  const calculateFromMinutes = (minutes) => {
    let days = 0;
    let weeks = 0;
    let months = 0;

    if (minutes % (24 * 60) === 0) {
      days = minutes / (24 * 60);
    }

    if (minutes % (7 * 24 * 60) === 0) {
      weeks = minutes / (7 * 24 * 60);
    }

    if (minutes % (30 * 24 * 60) === 0) {
      months = minutes / (30 * 24 * 60);
    }

    return { days, weeks, months };
  };

  useEffect(() => {
    if (localStorage.getItem("autoManagerState")) {
      const localStorageData = JSON.parse(
        localStorage.getItem("autoManagerState")
      );

      if (localStorageData) {
        setTimeout(() => {
          setSearch(localStorageData.search);
          dispatch(setStorage(localStorageData));

          debouncedCallApi();
        }, 1000);
      }
    }
  }, []);

  useEffect(() => {
    dispatch(fetchAutoAssign(id));

    return () => {
      dispatch(isAddingAction(false));
    };
  }, []);

  useEffect(() => {
    setEditingLoading(updateLoading);
    if (!updateLoading) {
      setEditingKey("");
    }
  }, [updateLoading]);

  useEffect(() => {
    setData(allAutoAssign);
  }, [allAutoAssign]);

  useEffect(() => {
    let filteredData = allAutoAssign;

    if (search?.name?.length > 0) {
      filteredData = filteredData.filter((el) =>
        el.name?.toLowerCase()?.includes(search.name?.toLowerCase())
      );
    }

    if (search?.deleted_status?.length > 0) {
      filteredData = filteredData.filter(
        (el) => el.deleted_status === search.deleted_status
      );
    }

    setData(filteredData);
  }, [req]);

  useEffect(() => {
    const isSearchChanged =
      JSON.stringify(search) !== JSON.stringify(rest.search);

    if (isSearchChanged) {
      setSearch(rest.search);
    }

    if (isSearchChanged) {
      debouncedCallApi();
    }
  }, []);

  const changeHandler = (event) => {
    const image = event.target.files[0];
    if (!image) {
      return false;
    }
    if (!image.name.match(/\.(svg|png)$/)) {
      message.error("Photo should be svg or png format.");
      return false;
    }
    if (image.size > 5120000) {
      message.error("Photo size should be less than 5MB.");
      return false;
    }
    setIcon(event.target.files[0]);
    setIsIconSelected(true);
  };

  const EditableCell = ({
    editing,
    dataIndex,
    title,
    inputType,
    record,
    index,
    children,
    ...restProps
  }) => {
    const numberInput = (
      <InputNumber
        placeholder="Insert Range"
        ref={ref}
        min={1}
        // max={10}
        width={120}
        onKeyPress={(e) => {
          if (e.key === "Enter") {
            save(record._id, id);
          }
        }}
      />
    );
    const textInput = (
      <Input
        placeholder="Insert Badge Name"
        ref={ref}
        onKeyPress={(e) => {
          if (e.key === "Enter") {
            save(record._id, id);
          }
        }}
      />
    );

    if (["start_range", "end_range"].includes(dataIndex)) {
      return (
        <td {...restProps}>
          {editing ? (
            <Form.Item
              name={dataIndex}
              style={{
                margin: 0,
                width: "100%",
              }}
              rules={[
                {
                  required: true,
                  message: `Required!`,
                },
              ]}
            >
              {numberInput}
            </Form.Item>
          ) : (
            children
          )}
        </td>
      );
    }

    let inputNode = null;

    if (dataIndex === "icon") {
      inputNode = (
        <div style={{ width: "40px" }}>
          <div
            style={{
              width: "30px",
              height: "30px",
              textAlign: "center",
            }}
          >
            <img
              width="100%"
              height="100%"
              style={{
                objectFit: "contain",
              }}
              src={
                isIconSelected
                  ? URL.createObjectURL(icon)
                  : icon
                  ? `${baseURL}/${icon}`
                  : sampleImg
              }
              alt=""
            />
          </div>
          <div
            className="edit-icon-div"
            style={
              {
                // textAlign: 'center',
              }
            }
          >
            <input
              // readOnly={loading}
              // disabled={!isEdit}
              type="file"
              name="profileImg"
              id="profileImg"
              accept="image/*"
              style={{ display: "none" }}
              onChange={changeHandler}
            />
            <label
              htmlFor="profileImg"
              style={{
                paddingLeft: "10px",
              }}
            >
              <EditIcon height={14} width={14} fill="#50B6F2" />
            </label>
          </div>
        </div>
      );
    }

    if (dataIndex === "name") {
      return (
        <td {...restProps}>
          {editing ? (
            <Form.Item
              name={dataIndex}
              style={{
                margin: 0,
              }}
              rules={[
                {
                  required: true,
                  message: `This field is required!`,
                },
                {
                  min: 1,
                  message: `invalid!`,
                },
              ]}
            >
              {textInput}
            </Form.Item>
          ) : (
            children
          )}
        </td>
      );
    }

    if (dataIndex === "deleted_status") {
      inputNode = (
        <Select
          showSearch
          className={`deleted-status-selector`}
          style={{ width: "100px", height: "30px" }}
          getPopupContainer={() =>
            document.getElementsByClassName(
              "ant-layout-content layout-content site-layout-background custom-textarea"
            )[0]
          }
          dropdownClassName="select-dropdown-custom"
          size="small"
          optionFilterProp="children"
          filterOption={(input, option) =>
            option.children.toLowerCase().indexOf(input.toLowerCase()) >= 0
          }
          // onChange={handleUpdateSite}
          placeholder="Select Status"
          optionLabelProp="label"
        >
          {[
            { label: "ACTIVE", value: "active" },
            { label: "INACTIVE", value: "inactive" },
          ]?.map(({ label, value }) => {
            return (
              <Option value={value} key={value} label={label}>
                {label || ""}
              </Option>
            );
          })}
        </Select>
      );
    }

    return (
      <td {...restProps}>
        {editing ? (
          <Form.Item
            valuePropName={"value"}
            name={dataIndex}
            style={{
              margin: 0,
            }}
            rules={[
              {
                required: true,
                message: `Required!`,
              },
            ]}
          >
            {inputNode}
          </Form.Item>
        ) : (
          children
        )}
      </td>
    );
  };

  const edit = (record) => {
    dispatch(isAddingAction(true));
    if (record?.isAdd) {
    } else {
      setIcon(record.icon || null);
    }
    form.setFieldsValue({
      ...record,
    });
    setEditingKey(record._id);
    setTimeout(() => {
      ref.current?.focus();
    }, 300);
    setIsIconSelected(false);
  };

  const cancel = (record) => {
    dispatch(isAddingAction(false));
    form.resetFields();
    setEditingKey("");
    if (record?.isAdd) {
      return setData((data) => data.filter((el) => el._id !== record._id));
    } else {
      setData(data);
    }
  };

  const save = async (id) => {
    if (!icon) {
      return message.error("Auto Assign Icon is required!");
    }
    try {
      const row = await form.validateFields();
      const newData = [...data];
      const index = newData.findIndex((item) => id === item._id);

      if (index > -1) {
        const item = newData[index];
        if (item?.isAdd) {
          form.submit();
        } else {
          // if (isAlreadyExist({ ...item, ...row })) {
          //   return message.error("Badges name already exist!");
          // }

          const { name, start_range, end_range, deleted_status } = row;
          dispatch(
            updateAutoAssign({
              name,
              start_range,
              end_range,
              badge: icon,
              deleted_status,
              auto_badge_id: id,
            })
          );
        }
      }
    } catch (errInfo) {
      if (errInfo?.values?.name === "") {
        message.error("Name should not be blank!");
      }
    }
  };

  const handleAdd = () => {
    dispatch(isAddingAction(true));
    let _id = Math.floor(Math.random() * 1122123456);
    const newData = {
      _id,
      icon: null,
      name: "",
      deleted_status: "active",
      isAdd: true,
    };
    setData((data) => [newData, ...data]);
    setEditingKey(_id);
    setIcon(null);
    edit(newData);
  };

  // const isAlreadyExist = (record) => {
  //   const { name } = record;
  //   const alreadyExist = data.filter(
  //     (el) => el.name?.trim()?.toLowerCase() === name?.trim()?.toLowerCase()
  //   );

  //   return alreadyExist.length > 0 && record._id !== alreadyExist[0]?._id
  //     ? true
  //     : false;
  // };

  const handleFinish = (values) => {
    const { name, deleted_status, start_range, end_range } = values;

    // if (isAlreadyExist(values)) {
    //   return message.error("Status name already exist!");
    // }

    dispatch(
      createAutoAssign({
        name,
        start_range,
        end_range,
        badge: icon,
        deleted_status,
      })
    );
  };

  const handleSetStorage = (key, value) => {
    dispatch(setStorage({ [key]: value }));
  };

  const handleSearch = (key, value, func = null) => {
    let updatedState = {
      ...search,
      [key]: value,
    };

    setSearch(updatedState);

    if (typeof func === "function") {
      func();
    }

    dispatch(setStorage({ search: updatedState }));
    handleSetStorage("search", updatedState);
  };

  const searchInput = (key) => (
    <Input
      onClick={(e) => {
        e.stopPropagation();
      }}
      value={search[key]}
      onChange={(e) => {
        handleSearch(key, e.target.value, debouncedCallApi);
      }}
    />
  );

  const columns = [
    {
      title: () => {
        return (
          <div align="top" style={{ width: "100%" }}>
            <div className="special-table-header-text">Icon</div>
            <div style={{ height: "25px" }}></div>
          </div>
        );
      },
      dataIndex: "icon",
      key: "icon",
      width: "20%",
      editable: true,
      align: "left",
      render: (icon, record) => {
        if (!icon) {
          return;
        }

        return (
          <div
            style={{
              width: "30px",
              height: "30px",
              textAlign: "center",
            }}
          >
            <img
              width="100%"
              height="100%"
              style={{
                objectFit: "contain",
              }}
              src={`${baseURL}/${icon}`}
              alt="icon"
            />
          </div>
        );
      },
    },
    {
      title: () => {
        return (
          <div align="top" style={{ width: "100%" }}>
            <div className="special-table-header-text">Badge Name</div>
            <div>{searchInput("name")}</div>
          </div>
        );
      },
      dataIndex: "name",
      key: "name",
      width: "30%",
      editable: true,
      sorter: (a, b) => a.name.localeCompare(b.name),
    },
    {
      title: "Start Range",
      dataIndex: "start_range",
      key: "start_range",
      width: "15%",
      editable: true,
      required: true,
      align:"center",
    },
    {
      title: "End Range",
      dataIndex: "end_range",
      key: "end_range",
      width: "15%",
      editable: true,
      required: true,
      align:"center",
    },
    {
      title: () => {
        return (
          <div align="top" style={{ width: "100%" }}>
            <div className="special-table-header-text">Status</div>
            <div key={"1"}>
              <Select
                style={{
                  width: "100%",
                  textTransform: "capitalize",
                }}
                size="small"
                onClick={(e) => e.stopPropagation()}
                allowClear={true}
                readOnly={true}
                className="Select Gender"
                dropdownClassName="select-dropdown-custom"
                getPopupContainer={() =>
                  document.getElementsByClassName(
                    "ant-layout-content layout-content site-layout-background custom-textarea"
                  )[0]
                }
                showSearch
                placeholder=""
                value={search?.deleted_status}
                optionFilterProp="children"
                onChange={(e) =>
                  handleSearch("deleted_status", e, debouncedCallApi)
                }
                optionLabelProp="label"
                filterOption={(input, option) =>
                  option?.children
                    ?.toLowerCase()
                    .indexOf(input.toLowerCase()) >= 0
                }
              >
                {[
                  { label: "ACTIVE", value: "active" },
                  { label: "INACTIVE", value: "inactive" },
                ]?.map(({ label, value }) => {
                  return (
                    <Option value={value} label={label}>
                      {label || ""}
                    </Option>
                  );
                })}
              </Select>
            </div>
          </div>
        );
      },
      dataIndex: "deleted_status",
      key: "deleted_status",
      width: "30%",
      editable: true,
      align: "center",
      sorter: (a, b) => a.deleted_status?.localeCompare(b.deleted_status),
      render: (deleted_status) => {
        return (
          <div style={{ paddingLeft: "12px" }}>
            {deleted_status?.toUpperCase()}
          </div>
        );
      },
    },
    {
      title: "Actions",
      key: "action",
      dataIndex: "",
      width: "20%",
      align: "center",
      render: (_, record) => {
        if (!canUpdate && !canDelete) {
          return;
        }

        const editable = isEditing(record);
        return editable ? (
          editingLoading && editingKey === record._id ? (
            <SpinnerComponent fontSize={14} />
          ) : (
            <Space size={20} align="center">
              <SaveIcon
                className="custom-icon"
                onClick={() => save(record._id, id)}
              />
              <Popconfirm
                title="Sure to cancel?"
                onConfirm={() => cancel(record)}
              >
                <CrossIcon
                  style={{ height: "20px", width: "20px" }}
                  className="custom-icon"
                />
              </Popconfirm>
            </Space>
          )
        ) : (
          <Space size={20} align="center">
            {canUpdate && (
              <EditIcon
                className={`custom-icon ${isAdding ? "disable-icon" : ""}`}
                disabled={editingKey !== ""}
                onClick={() => !isAdding && edit(record)}
              />
            )}
          </Space>
        );
      },
    },
  ];

  const mergedColumns = columns.map((col) => {
    if (!col.editable) {
      return col;
    }

    return {
      ...col,
      onCell: (record) => ({
        record,
        inputType: "text",
        dataIndex: col.dataIndex,
        editing: isEditing(record),
      }),
    };
  });

  useEffect(() => {
    dispatch(fetchAutoAssignTime());
  }, [dispatch]);

  const handleViewNow = () => {
    setIsModalVisibles(true);
  };

  const handleCancelNow = () => {
    setIsModalVisibles(false);
  };
  const handleViewLater = async () => {
    dispatch(fetchAutoAssignTime());
    setIsModalVisible(true);
  };

  const handleCancel = () => {
    setIsModalVisible(false);
  };

  const handleConfirmClick = () => {
    dispatch(
      updateAutoTime({
        intervalTime: totalMinutes,
        job_initialize_time: initializTtime,
        setIsModalVisible,
      })
    );
  };

  const handleYesClick = () => {
    dispatch(updateAutoNow());
    setIsModalVisibles(false);
    setEditingKey(true);
  };

  useEffect(() => {
    if (!updateLoading) {
      setEditingKey(false);
    }
  }, [updateLoading]);

  return (
    <>
      <Row justify="center" className="production-manager-parent-row">
        <Col span={24} className="heading-col">
          <Row align="middle" gutter={[50, 0]} justify="space-between">
            <Col>
              <Row gutter={[50, 0]} align="middle">
                <Col>
                  <div>
                    <span className="heading-span">Auto Assign</span>
                  </div>
                </Col>
                {canUpdate && (
                  <Col>
                    <Button
                      icon={<PlusOutlined />}
                      className="add-doc-btn class-btn"
                      size="middle"
                      onClick={handleAdd}
                      disabled={isAdding}
                      // disabled={shouldAddBtnDisable()}
                    >
                      Auto Assign
                    </Button>
                  </Col>
                )}
                <Col>
                  <Button
                    onClick={() => {
                      handleSetStorage("search", {});
                      setSearch({});
                      debouncedCallApi();
                    }}
                    icon={<CloseOutlined />}
                    className="add-user-btn"
                    size="middle"
                  >
                    Clear Filters
                  </Button>
                </Col>
                <Col>
                  <Button
                    icon={<PlusOutlined />}
                    className="add-doc-btn class-btn"
                    size="middle"
                    onClick={handleViewNow}
                  >
                    Update Now
                  </Button>
                </Col>
                <Modal
                  title="Schedule Now"
                  open={isModalVisibles}
                  width={900}
                  onCancel={handleCancelNow}
                  footer={[
                    <Button key="cancel" onClick={handleCancelNow}>
                      No
                    </Button>,
                    <Button key="submit" onClick={handleYesClick}>
                      Yes
                    </Button>,
                  ]}
                >
                  <p>
                    Are You Sure! You want to update all students badges right
                    now?
                  </p>
                </Modal>
                <Col>
                  <Button
                    icon={<PlusOutlined />}
                    className="add-doc-btn class-btn"
                    size="middle"
                    onClick={handleViewLater}
                  >
                    Schedule Later
                  </Button>
                </Col>

                <Modal
                  title="Schedule Later"
                  open={isModalVisible}
                  width={900}
                  onCancel={handleCancel}
                  footer={[
                    <Button key="cancel" onClick={handleCancel}>
                      Cancel
                    </Button>,
                    <Button key="submit" onClick={handleConfirmClick}>
                      Confirm
                    </Button>,
                  ]}
                >
                  <p>
                    Select any Days,Weeks or Months to Schedule auto assigned
                    badges.
                  </p>
                  <div
                    style={{
                      display: "flex",
                      flexDirection: "column",
                      gap: "10px",
                    }}
                  >
                    <label>
                      Days:
                      <InputNumber
                        min={1}
                        max={6}
                        type="number"
                        placeholder="Enter days"
                        value={days}
                        onChange={handleDaysChange}
                        style={{ width: "100%", padding: "5px" }}
                      />
                    </label>

                    <label>
                      Weeks:
                      <InputNumber
                        min={1}
                        max={4}
                        type="number"
                        placeholder="Enter weeks"
                        value={weeks}
                        onChange={handleWeeksChange}
                        style={{ width: "100%", padding: "5px" }}
                      />
                    </label>

                    <label>
                      Months:
                      <InputNumber
                        min={1}
                        type="number"
                        placeholder="Enter months"
                        value={months}
                        onChange={handleMonthsChange}
                        style={{ width: "100%", padding: "5px" }}
                      />
                    </label>
                    <CountdownTimer
                      lastRunTime={scheduleMin?.last_ran_job}
                      updatedAt={scheduleMin?.updatedAt}
                      intervalMinutes={scheduleMin?.auto_interval_time}
                    />
                    {/* <h3>Total Minutes: {totalMinutes}</h3> */}
                  </div>
                </Modal>
              </Row>
            </Col>
          </Row>
        </Col>
        <Col md={24} lg={23} xl={20} xxl={20} style={{ minHeight: "60vh" }}>
          {updateLoading && (
            <div
              style={{
                position: "absolute",
                top: 0,
                left: "50%",
                transform: "translateX(-50%)",
                backgroundColor: "rgba(255, 255, 255, 0.6)",
                display: "flex",
                justifyContent: "center",
                alignItems: "flex-start",
                paddingTop: "20px",
                zIndex: 9999,
                width: "100%",
                height: "100%",
              }}
            >
              <Spin fontSize={40} />
            </div>
          )}

          <Form
            form={form}
            component={false}
            onFinish={handleFinish}
            className="table-style"
          >
            <Table
              className="special-table activity-type-table project-statuses-table"
              style={{
                marginTop: "30px",
              }}
              components={{
                body: {
                  cell: EditableCell,
                  // wrapper: DraggableContainer,
                  // row: DraggableBodyRow,
                },
              }}
              scroll={{ x: !fetchingLoading }}
              rowClassName="editable-row"
              dataSource={data}
              loading={fetchingLoading}
              columns={mergedColumns}
              pagination={false}
              rowKey="position"
            />
          </Form>
        </Col>
      </Row>
    </>
  );
};

export default AutoAssignTable;
